import unauthenticatedHttp from "@/services/unauthenticatedHttp";

export function postTelemetries(data: any) {
  return unauthenticatedHttp()
    .post(`${window.env.API_UNAUTH}/telemetry`, data)
    .catch(() => {
      // Ignore telemetry errors
    });
}
